/**
 * Плашка демонстрационного режима ИИ-разбора (CR-4).
 *
 * Показывается на обоих экранах эпика, пока владелец не подтвердил боевой режим. Текст приходит
 * С СЕРВЕРА и здесь не сочиняется: предупреждений два — про бесплатный тариф (документы могут
 * пойти на обучение модели) и мягкое «режим ещё не боевой», — а какое из них верно, знает
 * конфигурация инстанса, а не браузер.
 *
 * Почему плашка, а не строчка в углу: человек, отправляющий договор заказчика, должен увидеть
 * предупреждение ДО отправки, не разыскивая его.
 */
export function DemoModeBanner({ notice }: { notice: string }) {
  if (notice.trim() === "") return null;
  return (
    <div
      role="status"
      className="mt-4 rounded-[var(--radius-l)] border border-soon-fg/40 bg-soon-bg p-4 text-[14px] text-ink"
    >
      <p className="font-bold">Демонстрационный режим</p>
      <p className="mt-1 max-w-[var(--w-text)]">{notice}</p>
    </div>
  );
}
